import { useCallback, useState } from 'react';

import {
  AttendanceCellClickHandler,
  AttendanceGridStudent,
  AttendanceSidebarData,
} from '../common/types';

type AttendanceSidebarSelection = {
  data: AttendanceSidebarData;
  student: AttendanceGridStudent;
};

export type UseAttendanceSidebar = {
  selected: AttendanceSidebarSelection | null;
  openForCell: AttendanceCellClickHandler;
  close: () => void;
};

export const useAttendanceSidebar = (): UseAttendanceSidebar => {
  const [selected, setSelected] = useState<AttendanceSidebarSelection | null>(null);

  const openForCell = useCallback<AttendanceCellClickHandler>((data, student) => {
    setSelected({ data, student });
  }, []);

  const close = useCallback(() => {
    setSelected(null);
  }, []);

  return {
    selected,
    openForCell,
    close,
  };
};
